import { useLayoutEffect, useRef, type ReactNode } from "react";
import { initializeStaffAppearancePreferences } from "../utils/appearancePreferences";
import "./staff-design-preferences.css";
import "./staff-typography.css";
import "./staff-design-surfaces.css";
import "./staff-design-detail.css";
import "./staff-design-name-flow.css";

/** Authentication owns this boundary; public and printed surfaces never opt in. */
export function StaffDesignBoundary({ children }: { children: ReactNode }) {
  const root = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (root.current) initializeStaffAppearancePreferences(root.current);
  }, []);
  return <div ref={root} data-staff-design="true" style={{ display: "contents" }}>{children}</div>;
}
